'use client';
import { type ReactNode } from 'react';
import { useElementSize } from '@/hooks/useElementSize';
import { useCssVar } from '@/hooks/useCssVar';

export function BannerHeightSync({ children }: { children: ReactNode }) {
    const [ref, { height }] = useElementSize<HTMLDivElement>();

    useCssVar('--announcement-banner-height', height);

    return <div ref={ref}>{children}</div>;
}
